import { DataCard } from "@/components/DataCard";
import { Clock, Bot, Timer, AlertTriangle } from "lucide-react";

const findings = [
  {
    tag: "Bot activity",
    stat: "30-40%",
    statLabel: "of opens are bots",
    description: "GetResponse data shows that 30-40% of recorded email opens come from security scanning tools like Microsoft Defender, not real recipients. These tools click every link within milliseconds.",
    bullets: [
      "Security scanners pre-click all links automatically.",
      "Clicks within 2-3 seconds are flagged as non-human."
    ],
    icon: Bot
  },
  {
    tag: "Spam threshold",
    stat: "0.3%",
    statLabel: "complaint limit",
    description: "Google and Yahoo enforce a strict 0.3% spam complaint threshold as of 2024. Exceeding this limit causes immediate redirection of all your messages to spam folders.",
    bullets: [
      "Both Gmail and Yahoo enforce identical thresholds.",
      "High-frequency senders face stricter monitoring."
    ],
    icon: AlertTriangle
  },
  {
    tag: "Volume impact",
    stat: "29.31%",
    statLabel: "peak spam rate",
    description: "Senders with 50k-200k monthly emails see 29.31% spam rates. However, high-volume senders (1M+) who maintain consistent patterns achieve just 16.24% spam rates.",
    bullets: [
      "Gradual volume increases build reputation.",
      "Sudden spikes trigger throttling and filtering."
    ],
    icon: Timer
  },
  {
    tag: "AI filtering",
    stat: "LLM-based",
    statLabel: "detection systems",
    description: "Gmail and Microsoft now use large language models to identify unnatural tone, repeated patterns, and mass-generated templates linked to automation.",
    bullets: [
      "AI evaluates context, not just keywords.",
      "Human oversight on AI content improves results."
    ],
    icon: Clock
  }
];

export const SendingTimeKeyFindings = () => {
  return (
    <section className="section-card mt-0">
      <div className="flex flex-col sm:flex-row sm:justify-between sm:items-baseline gap-1.5 sm:gap-2 mb-5 sm:mb-6">
        <h2 className="font-display text-lg sm:text-xl font-semibold tracking-tight text-foreground">
          Key findings from industry research
        </h2>
        <p className="text-[11px] sm:text-xs text-muted-foreground">
          Data from Validity, GetResponse, and Litmus (2024-2025)
        </p>
      </div>

      <div className="grid md:grid-cols-2 gap-3 sm:gap-4">
        {findings.map((finding, i) => (
          <DataCard key={i} {...finding} />
        ))}
      </div>

      {/* Source attribution */}
      <p className="mt-4 text-[10px] text-muted-foreground text-center">
        Statistics from Validity 2024/2025 Deliverability Benchmark, GetResponse Email Marketing Benchmarks, and Litmus State of Email 2025
      </p>
    </section>
  );
};
